<ng-container>
    <div class="grid-tooltip" libTooltip [position]="currentPosition" [innerHtml]="safeTooltipContent"></div>
</ng-container>
